var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect } from "react";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { BigNumber } from "@ethersproject/bignumber";
import { proof, airdrop, breakdown } from "../constants/constants";
import useMerkleDistributor from "./useMerkleDistributor";
import { usePendingTransactions } from "shared/lib/hooks/pendingTransactionsContext";
import { formatUnits } from "@ethersproject/units";
import { impersonateAddress } from "shared/lib/utils/development";
import { useGlobalState } from "shared/lib/store/store";
import { CHAINID } from "shared/lib/utils/env";
var useAirdrop = function () {
    var web3Context = useWeb3Wallet();
    var chainId = web3Context.chainId;
    var account = impersonateAddress ? impersonateAddress : web3Context.account;
    var merkleDistributor = useMerkleDistributor();
    var _a = useGlobalState("airdropInfo"), airdropInfo = _a[0], setAirdropInfo = _a[1];
    var pendingTransactions = usePendingTransactions().pendingTransactions;
    var updateAirdropInfo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var airdropClaim, airdropBreakdown, total, claimed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (chainId !== CHAINID.ETH_MAINNET || !account || !merkleDistributor) {
                        setAirdropInfo(undefined);
                        return [2 /*return*/];
                    }
                    airdropClaim = proof["claims"][account];
                    airdropBreakdown = Object.fromEntries(Object.keys(breakdown)
                        .map(function (key) { return [[key], breakdown[key][account]]; })
                        .filter(function (entry) { return entry[1]; }));
                    total = airdrop[account]
                        ? parseFloat(formatUnits(BigNumber.from("0x" + airdrop[account]), 18))
                        : 0;
                    if (!airdropClaim || !airdropBreakdown || !total) {
                        setAirdropInfo(undefined);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, merkleDistributor.isClaimed(airdropClaim.index)];
                case 1:
                    claimed = _a.sent();
                    setAirdropInfo({
                        account: account,
                        total: total,
                        proof: __assign(__assign({}, airdropClaim), { amount: BigNumber.from(airdropClaim.amount) }),
                        breakdown: airdropBreakdown,
                        claimed: claimed,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [account, merkleDistributor, setAirdropInfo, chainId]);
    useEffect(function () {
        if (!airdropInfo || airdropInfo.account !== account) {
            updateAirdropInfo();
        }
    }, [account, airdropInfo, updateAirdropInfo]);
    useEffect(function () {
        var _a;
        if (((_a = pendingTransactions[pendingTransactions.length - 1]) === null || _a === void 0 ? void 0 : _a.type) === "claim") {
            setAirdropInfo(function (prev) { return (prev ? __assign(__assign({}, prev), { total: 0 }) : undefined); });
        }
    }, [pendingTransactions, setAirdropInfo]);
    return airdropInfo;
};
export default useAirdrop;
//# sourceMappingURL=useAirdrop.js.map